<div class="adx-lib-widget-view-wrapper">
    <div #obcNavigationInstrumentContainer class="adx-navigations-instrument-wrapper">
        <div class="adx-obc-navigations-instrument-compass">
            <obc-compass
                    [heading]="obcNavigationsInstrumentsInstance.compass.heading"
                    [courseOverGround]="obcNavigationsInstrumentsInstance.compass.courseOverGround"
                    [headingAdvices]="obcNavigationsInstrumentsInstance.compass.headingAdvices"
            >
            </obc-compass>
        </div>
    </div>
</div>
